import { fg } from '@atlassian/jira-feature-gating';
import type { CookieCircuitBreakerConfig } from '@atlassian/jira-route-types/src/JiraSpaRoute.tsx';

export function getIssueCircuitBreaker(): CookieCircuitBreakerConfig {
	return {
		isSetCookieEnabled: fg('jfp-magma-ssr-cookie-cb'),
		isMonitoringEnabled: fg('jfp-magma-ssr-cookie-cb'),
		isBailoutEnabled: fg('jfp-magma-ssr-cookie-cb-bailout'),
		cookieKey: 'iss',
		windowSize: 20,
		threshold: 0.2,
		keepOpenCount: 200,
		halfOpenForCount: 10,
	};
}
